import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import LoadingScreen from '@/components/LoadingScreen'
import { GlobalSetting, settingService } from '@/services/page'
import { APPS } from '@/appConfig'
import pathService from '@/services/path'
import { GetStaticPaths, GetStaticProps } from 'next'
import { ParsedUrlQuery } from 'querystring'
import Page from '@/components/Page'

interface PathProps extends ParsedUrlQuery {
  appId: string
}

interface LogoutPageProps {
  globalSetting?: GlobalSetting
}

export default function LogoutPage({ globalSetting }: LogoutPageProps) {
  const companyColor = globalSetting?.companyColor ?? undefined
  const { query, push } = useRouter()
  const { returnTo } = query

  useEffect(() => {
    if (returnTo && typeof returnTo === "string") {
      push(returnTo)
    }
  }, [returnTo, push])

  return (
    <Page title="logout">
      <LoadingScreen companyColor={companyColor} />
    </Page>
  )
}


export const getStaticPaths: GetStaticPaths<PathProps> = async () => {
  const { getDefaultPaths } = pathService()
  const paths = APPS.flatMap((app) => getDefaultPaths(app.id))

  return {
    paths,
    fallback: true,
  }
}

export const getStaticProps: GetStaticProps<LogoutPageProps, PathProps> = async ({
  params,
  locale,
}) => {
  if (!params) throw new Error('No path parameters found')

  const { appId } = params

  const { getGlobalSetting } = settingService(appId)
  const [globalSetting] = await Promise.all([getGlobalSetting({ locale })])

  return {
    props: {
      globalSetting,
    },
  }
}